import { NewsletterGroupResponseDto } from "types/Newsletter"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const newsletterGroupsReducer: RemoteReducer<
  NewsletterGroupResponseDto[]
> = createRemoteReducer("newsletterGroups")
